import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementPlus from 'element-plus';
// import 'element-plus/lib/theme-chalk/index.css';
import 'element-plus/dist/index.css';
import './assets/element-icon/icon.css';
import base from './utils/common';
import enums from './utils/enums';
import http from './api/http';
import runtimeConfig from './api/runtimeConfig';
// import 'dayjs/locale/zh-cn'
// import locale from 'element-plus/lib/locale/lang/zh-cn'
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import dayjs from 'dayjs';

// var utc = require('dayjs/plugin/utc');
import utc from 'dayjs/plugin/utc'; // ES 2015

dayjs.extend(utc);
import * as echarts from 'echarts';
import VueBMap from 'vue-bmap-gl';
import DataV from '@kjgl77/datav-vue3';

import permission from './api/permission';
import viewgird from './components/basic/ViewGrid';
http.initRuntimeBaseURL().then(() => {
  document.title = http.runtimeConfig?.projectName || '';
  const app = createApp(App);
  app.use(DataV);
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
  }
  app.config.globalProperties.base = base;
  app.config.globalProperties.enums = enums;
  app.config.globalProperties.http = http;
  app.config.globalProperties.config = runtimeConfig;
  app.config.globalProperties.$tabs = {};
  app.config.globalProperties.permission = permission;
  app.config.globalProperties.$dayjs = dayjs;
  app.config.globalProperties.$echarts = echarts;
  app.config.globalProperties.$global = {
    signalR: true, //是否开启signalR
    menuSearch: true, //菜单是否启用搜索功能
    table: {
      smallCell: false, //表格单元格大小
      useTag: true //table组件下拉框数据源的字段是否显示背景颜色
    },
    audit: {
      //审核选项
      data: [
        { text: '通过', value: 1 },
        { text: '拒绝', value: 3 },
        { text: '驳回', value: 4 }
      ],
      status: [0, 2] //审核中的数据
      // 待审核 = 0,
      // 审核通过 = 1,
      // 审核中 = 2,
      // 审核未通过 = 3,
      // 驳回 = 4
    }
  };
  //2023.03.13，
  //修改见：volupload.vue，后台AliOSSController.cs，阿里云OSS配置.doc
  window.oss = {
    ali: {
      //阿里云
      use: false, //使用阿里云上传文件
      //阿里缩略图压缩大小
      //.aliyuncs.com
      small: '?x-oss-process=image/resize,m_lfit,w_200'
    }
  };
  app.use(VueBMap, {
    ak: 'NH5Ll8QIyfMJhbyBVUOnDILw6lpXAYaP'
  });
  app.use(store).use(ElementPlus, { size: 'default' }).use(router).use(viewgird).mount('#app');
  app.config.globalProperties.$Message = app.config.globalProperties.$message;
  // sso登录:shaun:2025-10-23
  function redirectToSsoIfNeeded() {
    // 如果没有启用认证中心登录，则不需要处理
    if (!http.runtimeConfig.authType) return;

    const current = router.currentRoute.value;
    const isAnonymous = current.matched && current.matched.some((r) => r.meta && r.meta.anonymous);
    const isSsoCallback = current.path === '/sso/callback' || current.name === 'ssoCallback';
    if (isAnonymous || isSsoCallback) return;
    if (!store.getters.isLogin()) {
      const url = `${http.runtimeConfig.authBase}#/login?client_id=${encodeURIComponent(http.runtimeConfig.clientId)}&redirect_uri=${encodeURIComponent(http.runtimeConfig.redirectUri)}`;
      window.location.href = url;
    }
  }
  router.isReady().then(() => {
    redirectToSsoIfNeeded();
  });
  window.addEventListener('focus', () => {
    redirectToSsoIfNeeded();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      redirectToSsoIfNeeded();
    }
  });
});
